<template>

    <div>

        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.unidades"
                        :validations="validations.unidade"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        :disabled="model.unidadeDisabled ? true : false"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        :validations="validations.infraestrutura"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        :disabled="model.unidadeDisabled ? true : false"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="12">

                    <rkm-form-checkbox
                        inline
                        v-model="model.urgencia"
                    >
                        Urgência/Emergência
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row>

            <rkm-col
                cols="12"
            >
                <rkm-area
                    title="Exames"
                    type="fieldset"
                >
                    <FormExame
                        ref="FormExame"
                        :data="data"
                        @exames="handleExames"
                    />
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

// Components.
import FormExame from './exames/Form'

export default {
    components: { FormExame },
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.data.form.unidades.find(u => u.id === this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.load()
    },
    data: () => ({
        form: {
            unidades: {},
        },
        model: {
            id: null,
            unidadeId: null,
            infraestruturaId: null,
            unidadeDisabled: false,
            urgencia: false,
            infraestrutura: [],
            exames: []
        },
        unidadeColeta: [],
    }),
    methods: {
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.unidadesSolicitantes.findIndex((obj => obj.id == this.item.id));

                const data = this.data.model.unidadesSolicitantes[objId]

                this.model.id = data.id
                this.model.unidadeId = data.unidadeId
                this.model.infraestruturaId = data.infraestruturaId
                this.model.unidadeDisabled = true
                this.model.urgencia = data.urgencia
                this.model.exames = data.exames

                this.$nextTick().then(() => this.$refs.FormExame.handleExames(data.exames))
            }
        },
        getPrincipal(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {
                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {
                this.model.infraestruturaId = null
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (this.hasUnidadeParametrizada()) {

                            this.showValidationNotification(
                                "Unidade já parametrizada com o local de atendimento"
                            )

                            return
                        }
                        else {

                            const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
                            const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                             if (this.index == null) {

                                this.model.id = this.uniqueId('unidade' + new Date().getTime())
                            }

                            const param = {
                                id: this.model.id,
                                unidadeId: unidade.id,
                                nomeFantasia: unidade.nomeFantasia,
                                infraestrutura: this.model.infraestrutura,
                                infraestruturaId: infraestrutura.id,
                                infraestruturaNome: infraestrutura.nome,
                                infraestruturaPrincipal: infraestrutura.principal,
                                urgencia: this.model.urgencia,
                                exames: this.model.exames,
                                alterado: true,
                            }

                            if (this.hasIndex) {

                                const objIndex = this.data.model.unidadesSolicitantes.findIndex((obj => obj.id == this.model.id));

                                this.$set(this.data.model.unidadesSolicitantes, objIndex, this.clone(param))
                            }
                            else {

                                this.data.model.unidadesSolicitantes.push(this.clone(param))
                            }

                            this.$emit('save', this.clone(param))
                        }
                })
        },
        hasUnidadeParametrizada() {

            return this.data.model.unidadesSolicitantes.find((unidade) => unidade.id !== this.model.id
                && unidade.unidadeId === this.model.unidadeId && unidade.infraestruturaId === this.model.infraestruturaId)
        },
        getUnidadeColetaSolicitante() {

            if (this.model.unidadeColeta === true) {
                return this.unidadeColeta
            } else {
                return []
            }
        },
        handleExames(exames) {
            this.model.exames = exames
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>